import { type ComponentType, memo } from 'react';
import { ProjectType } from '@trinity/chat/enums/project';
import Call from './Call';
import type { ProjectIconProps } from './interfaces';
import Mixed from './Mixed';
import Survey from './Survey';

type Props = {
  // Numeric to accept any app-local ProjectType enum (each consuming app currently
  // declares its own copy of this enum with matching numeric values).
  projectType: number;
} & ProjectIconProps;

const ICON_BY_PROJECT_TYPE: Partial<Record<number, ComponentType<ProjectIconProps>>> = {
  [ProjectType.Call]: Call,
  [ProjectType.Survey]: Survey,
  [ProjectType.SurveyCall]: Mixed,
};

export const ProjectIcon = memo(({ className, projectType, size = 28, color, style = {}, ...iconProps }: Props) => {
  const Icon = ICON_BY_PROJECT_TYPE[projectType];

  if (!Icon) {
    return null;
  }

  return (
    <Icon
      className={className}
      color={color}
      size={size}
      style={{ display: 'flex', flexShrink: 0, ...style }}
      {...iconProps}
    />
  );
});

export default ProjectIcon;
